import { render, staticRenderFns } from "./SalePeriodEdit.vue?vue&type=template&id=34c87480"
import script from "./SalePeriodEdit.vue?vue&type=script&lang=js"
export * from "./SalePeriodEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports